import { render, staticRenderFns } from "./XjTop.vue?vue&type=template&id=058e4628&scoped=true&"
import script from "./XjTop.vue?vue&type=script&lang=js&"
export * from "./XjTop.vue?vue&type=script&lang=js&"
import style0 from "./XjTop.vue?vue&type=style&index=0&id=058e4628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e4628",
  null
  
)

export default component.exports